/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'HOT_WORK_IS_PERFORMED_IN_AN_APPROVED_DESIGNATED_AREA_WHEN_POSSI',
              'HOT_WORK_OUTSIDE_OF_AN_APPROVED_DESIGNATED_AREA_REQUIRES_A_PERM',
              'APPROPRIATE_DISTANCE_OR_OTHER_CONTROLS_E_G_FIRE_WATCH_ARE_IN_PL',
              'AREAS_WHERE_HOT_WORK_IS_CONDUCTED_IS_APPROPRIATELY_VENTILATED',
              'HOT_WORK_EQUIPMENT_IS_INSPECTED_PRIOR_TO_USE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_13: valueSchema,
  },
}
